export enum FileType {
    PDF = 'PDF',
    DOC = 'DOC',
    DOCX = 'DOCX',
    PPTX = 'PPTX',
    JPG = 'JPG',
    JPEG = 'JPEG',
    PNG = 'PNG',
    CSV = 'CSV',
    PPT = 'PPT',
    EXCEL = 'EXCEL',
    VIDEO = 'VIDEO',
    UNKNOWN = 'UNKNOWN'
}
